import { RoutePath } from "#src/utils/route";
import { UserGroupsRoutePath } from "../../";

export const UserGroupDetailsRoutePath = UserGroupsRoutePath.concat(
  new RoutePath<"groupId">({
    path: "/:groupId/details",
    title: "User Group Details",
  })
);
